import type { FaireProductEntity } from "../../entity_types/product";

export const p_52g2u8gp23: FaireProductEntity = {
  token: "p_52g2u8gp23",
  type: "product",
  name: "Royal Palm- Mahjong Tile Display Case - Brass & Raffia",
  brandToken: "b_szjw5rycm7",
  brandName: "Tala Mahj",
  imageUrl:
    "https://cdn.faire.com/fastly/f1ddf66f02e8a57f59bd314519b491cc5d354ae87aa408b6854c1899e18ff590.webp",
  galleryImageUrls: [],
  priceDollars: 122.5,
  description:
    "Not meant to be tucked away, but beautifully displayed.\n\nOur Acrylic Mahjong Display Case transforms your tiles into an object of everyday luxury. Crafted from crystal-clear acrylic and finished with a sculptural bamboo-inspired handle and brushed brass hardware, it's designed to celebrate the beauty of the game long after play has ended.\n\nThoughtfully designed to protect your tiles between games, the case keeps every piece beautifully organized while allowing the artistry of your set to remain on full display. Whether styled on a coffee table, bookshelf, or bar, it becomes part of your home's décor—always within reach for an impromptu game.\n\nEqual parts display piece and heirloom storage, it's a refined finishing touch for the modern mahjong collection.\n\nDetails\nPremium 8mm crystal-clear acrylic construction\nBrass and woven raffia handle\nBrass hardware with turn-lock closure\nDesigned to beautifully display and protect your mahjong tiles\nHolds a complete 160-tile mahjong set\nMeasures 10.25\" L × 5.9\" W × 4\" H (26 × 15 × 10 cm)\nDesigned in Charleston, South Carolina\n\n\n",
  tags: [],
  msrpDollars: 245,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T04:52:47.493Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
